import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'associatedShipment'
})
export class AssociatedShipmentPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    if (value &&  value.length) {
      return value.map(ship => ship.release_id).join(", ");
    }
    return "";
  }

}
